// extracted by mini-css-extract-plugin
export var body = "_me-0";
export var sectionHeader = "_me-4";
export var shortcutColumns = "_me-2";
export var shortcutList = "_me-1";
export var shortcutSection = "_me-3";